/**
 * Obuna (subscription) API.
 */
import api from './api';
import { endpoints } from './endpoints';

/**
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function getTariffsList() {
  const res = await api.get(endpoints.tariffs);
  const raw = res?.data ?? res ?? {};
  const list = raw?.data ?? raw;
  return Array.isArray(list) ? list : [];
}

/**
 * Obuna holati: status, qancha kun qolgan, tugash sanasi.
 */
export async function getSubscriptionStatus() {
  const res = await api.get(endpoints.subscriptionStatus);
  const raw = res?.data ?? res ?? {};
  return {
    status: String(raw.status ?? raw.subscription_status ?? 'expired'),
    subscriptionStatus: String(raw.subscription_status ?? raw.status ?? 'expired'),
    daysUntilExpiry: Number(raw.days_until_expiry ?? 0),
    trialEndsAt: raw.trial_ends_at ?? null,
    subscriptionEndsAt: raw.subscription_ends_at ?? null,
    endsAt: raw.ends_at ?? raw.subscription_ends_at ?? raw.trial_ends_at ?? null,
    monthlyPrice: Number(raw.monthly_price ?? 0),
    isTrial: Boolean(raw.is_trial ?? false),
    isActive: Boolean(raw.is_active ?? false),
    isExpired: Boolean(raw.is_expired ?? true),
    tenantId: raw.tenant_id ?? null,
  };
}

/**
 * Click/Payme to'lov URL'ini yaratish.
 * @param {number} months - oy soni (1-12)
 * @param {'click'|'payme'} provider - to'lov provayderi
 */
export async function initiateSubscriptionPayment(months = 1, provider = 'click', applyCashback = false) {
  const body = { months, provider };
  if (applyCashback) {
    body.apply_cashback = true;
  }
  const res = await api.post(endpoints.subscriptionInitiate, body);
  const raw = res?.data ?? res ?? {};
  return {
    payUrl: String(raw.pay_url ?? ''),
    /** Click: initiate paytida ichki Prepare sinovi (passed, prepare_error, hint, …) */
    clickPrepareSelfTest: raw.click_prepare_self_test && typeof raw.click_prepare_self_test === 'object'
      ? raw.click_prepare_self_test
      : null,
    amount: Number(raw.amount ?? 0),
    baseAmount: Number(raw.base_amount ?? raw.baseAmount ?? 0),
    discountPercent: Number(raw.discount_percent ?? raw.discountPercent ?? 0),
    grossAmount: Number(raw.gross_amount ?? raw.grossAmount ?? raw.amount ?? 0),
    cashbackApplied: Number(raw.cashback_applied ?? raw.cashbackApplied ?? 0),
    months: Number(raw.months ?? months),
    merchantTransId: String(raw.merchant_trans_id ?? ''),
    monthlyPrice: Number(raw.monthly_price ?? 0),
    provider: String(raw.provider ?? provider),
    initiateMethod: String(raw.initiate_method ?? 'POST'),
    initiatePath: String(raw.initiate_path ?? '/api/subscription/initiate'),
    providerDocsUrl: String(raw.provider_docs_url ?? ''),
    paymentRedirectBase: String(raw.payment_redirect_base ?? ''),
    /** Kabinet `/api`siz yozilganda: bir xil POST manzil */
    clickWebhookPostUrlNoPrefix: String(raw.click_webhook_post_url_no_api_prefix ?? ''),
    clickPrepareLogsExpectedHost: raw.click_prepare_logs_expected_host != null ? String(raw.click_prepare_logs_expected_host) : '',
    clickAppUrlHost: raw.click_app_url_host != null ? String(raw.click_app_url_host) : '',
    clickOperatorNote: String(raw.click_operator_note ?? ''),
    /** Click: backend sinovlari OK bo‘lsa ham checkout (-21) bo‘lishi mumkin — kabinet URL / WAF; qanday log qidirish */
    clickCheckoutDiagnosticHint: String(raw.click_checkout_diagnostic_hint ?? ''),
  };
}

/**
 * Marketing + onlayn buyurtmalar paketi (kichik biznes, bir marta).
 * @param {'click'|'payme'} provider
 */
export async function initiateMarketingAddonPayment(provider = 'click') {
  const res = await api.post(endpoints.subscriptionMarketingAddonInitiate, { provider });
  const raw = res?.data ?? res ?? {};
  return {
    payUrl: String(raw.pay_url ?? ''),
    amount: Number(raw.amount ?? 0),
    merchantTransId: String(raw.merchant_trans_id ?? ''),
    provider: String(raw.provider ?? provider),
  };
}
